<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
            <font-awesome-icon v-bind="attrs" v-on="on" :icon="icons.help" class="fa-lg" style="color:dodgerblue;" />
        </template>
        <div class="thresholdTooltip">
            <slot></slot>
        </div>
    </v-tooltip>
</template>

<script>
import { faInfoCircle } from "@fortawesome/pro-duotone-svg-icons";

export default {
    data() {
        return {
            icons: {
                help: faInfoCircle
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.v-tooltip__content.menuable__content__active {
    opacity: 1;
    background-color: #FFF;
    border: solid 1px #333;
    padding: 10px;
    color: #333;
}
.thresholdTooltip {
    font-style: italic;
}
</style>